import { z } from 'zod'

export const openUpdateSchema = z.object({
  masterTaskId: z.string(),
  updateType: z.string(),
})
